/*
*
* File JS componente Highlight Slider
*
*/

// IMPORT LIBRERIE ESTERNE
//--------------------------------------------------------------------//

import 'swiper/css';
import Swiper, { Navigation, Pagination } from 'swiper';
Swiper.use([Navigation, Pagination]);

//--------------------------------------------------------------------//


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './block-marchi-slider.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const marchiSlider = () =>
{
    let marchiSliderAll = document.querySelectorAll('.marchi-slider');
    if(!marchiSliderAll.length) return;
    
    marchiSliderAll.forEach(el =>
    {
        const swiperContainer = el.querySelector('.swiper-container');
        let arrowPrev = el.querySelector('.swiper-button-prev');
        let arrowNext = el.querySelector('.swiper-button-next');

        let pagination = el.querySelector('.swiper-pagination');

        let args =
        {
            slidesPerView: 'auto',
            spaceBetween: 40,
            speed: 600,
            centerInsufficientSlides: true,
            navigation: 
            {
                nextEl: arrowNext,
                prevEl: arrowPrev,
            },
            pagination: {
                el: pagination,
                clickable: true
            },
            a11y: {
                enabled: true,
                prevSlideMessage: 'Previous slide',
                nextSlideMessage: 'Next slide',
                firstSlideMessage: 'This is the first slide',
                lastSlideMessage: 'This is the last slide',
                paginationBulletMessage: 'Go to slide {{index}}',
                notificationClass: 'swiper-notification'
            },
        };

        new Swiper(swiperContainer, args);
    })
}

export default marchiSlider;

//--------------------------------------------------------------------//